// @flow

import type {CustomerSummary} from './customer-summary'
import type {ContractSummary} from './contract-summary'

export type CardSummary = {
  cardId: number,
  activeCommercial: boolean,
  engravedId: string,
  ascription: ?string,
  ascription1: ?string,
  ascription2: ?string,
  validUntil: ?Date,
  cardTheme: ?string,
  customer: ?CustomerSummary,
  contract: ?ContractSummary
}

const buildCardSummary = (): CardSummary => {
  return {
    cardId: 0,
    activeCommercial: true,
    engravedId: '',
    ascription: null,
    ascription1: null,
    ascription2: null,
    validUntil: null,
    cardTheme: null,
    customer: null,
    contract: null
  }
}

export {
  buildCardSummary
}



// WEBPACK FOOTER //
// ./src/types/card-summary.js